import { z } from 'zod';

export const booleanFromQueryParam = z.preprocess((value) => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (value == null || typeof value !== 'string') {
    return;
  }

  const normalized = value.trim().toLowerCase();
  if (
    normalized === '' ||
    normalized === 'false' ||
    normalized === '0' ||
    normalized === 'no' ||
    normalized === 'off'
  ) {
    return false;
  }

  if (normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on') {
    return true;
  }

  return;
}, z.boolean().optional());
